import type { AxiosRequestConfig } from 'axios'

import { SPANISH_SUBDIRECTORY } from '../../constants/api'
import { isApi2 } from './isApi2'
import { isCommonApi } from './isCommonApi'

export function getApiOrigin(axiosRequestConfig: AxiosRequestConfig) {
  let domain = import.meta.env.VITE_API_URL
  if (isCommonApi(axiosRequestConfig))
    domain = import.meta.env.VITE_COMMON_API_URL
  if (isApi2(axiosRequestConfig)) domain = import.meta.env.VITE_API_URL_2

  return `${domain}${SPANISH_SUBDIRECTORY}`
}
